import { Grid, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

export default function KeyboardShortcut({ name, keys }) {
  return (
    <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: 14,
            p: 0,
          }}
        >
          {name}
        </Typography>
        <Stack
          direction="row"
          sx={{
            gap: 0.5,
            alignItems: "center",
          }}
        >
          {keys.map((key) => (
            <kbd key={key}>{key}</kbd>
          ))}
        </Stack>
      </Stack>
    </Grid>
  );
}

KeyboardShortcut.propTypes = {
  name: PropTypes.string,
  keys: PropTypes.array,
};
